import React from "react";
import { Grid, Paper, Typography, Divider, Button, Box } from "@mui/material";
import { DirectionsCar, Edit, Person } from "@mui/icons-material";
import { ClienteData } from "../../../types/clientData";
import { maskDocument } from "../../../services/formatDocument";

const ClienteCard: React.FC<{
  client: ClienteData;
  handleEditButtonClick: (clientId: number) => void;
  handleAddCarButtonClick: (clientId: number) => void;
  handleViewVehicleButtonClick: (
    clientId: number,
    veiculos: { [key: number]: string } | null
  ) => void;
}> = ({
  client,
  handleEditButtonClick,
  handleViewVehicleButtonClick,
  handleAddCarButtonClick,
}) => (
  <Grid item xs={12}>
    <Paper
      elevation={4}
      sx={{
        p: 2,
        display: "flex",
        flexDirection: "column",
        height: 'auto',
        borderRadius: 3,
        cursor: "pointer",
        marginBottom: 1,
        backgroundColor: "#ffffff",
        position: "relative",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Person sx={{ fontSize: { xs: 70, sm: 60, md: 80 } }}></Person>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ border: 1, ml: 2 }}
        />
        <Grid container spacing={1} wrap="nowrap" ml={0.5}>
          <Grid item xs={12} sm={12} md={12}>
            <Typography sx={{ typography: { sm: "h5", xs: "button" } }} >
              {client.nome_cliente}
            </Typography>
            <Typography sx={{ typography: { sm: "body1", xs: "caption" } }}>
              Telefone: {client.telefone_contato_cliente}
            </Typography>
            <Typography sx={{ typography: { sm: "body1", xs: "caption" } }}>
              Documento: {maskDocument(client.documento_identificador_cliente)}
            </Typography>
          </Grid>
        </Grid>
        <Box
          sx={{ display: "flex", flexDirection: "column", marginLeft: "auto" }}
        >
          <Button
            variant="contained"
            sx={{
              bgcolor: "#303030",
              ":hover": { bgcolor: "#5c5c5c" },
              mb: 1,
            }}
            onClick={() => handleEditButtonClick(client.id)}
          >
            <Edit />
          </Button>
          <Button
            variant="contained"
            sx={{
              bgcolor:
                client.veiculos && Object.keys(client.veiculos).length > 0
                  ? "#4caf50"
                  : "#f44336",
              ":hover": {
                bgcolor:
                  client.veiculos && Object.keys(client.veiculos).length > 0
                    ? "#388e3c"
                    : "#d32f2f",
              },
            }}
            onClick={() => {
              if (client.veiculos && Object.keys(client.veiculos).length > 0) {
                handleViewVehicleButtonClick(client.id, client.veiculos);
              } else {
                handleAddCarButtonClick(client.id);
              }
            }}
          >
            <DirectionsCar />
          </Button>
        </Box>
      </Box>
    </Paper>
  </Grid>
);

export default ClienteCard;
